<div class="row col-12 p-0 m-0 main-page-section">
  <div class="col-12 p-0 ">
    <!-- <app-header></app-header> -->
    <div class="overview-image-container">
      <div class="text-position">
        <div class="start-building-sub">Start building our</div>
        <div class="start-building"> community</div>
        <div class="manage-organisations">
          Manage organisations and their members</div>
      </div>
      <img class="overview-image" src="/assets/images/overview-main-image-cla.png" />

    </div>

  </div>
  <div class="div-style">
    <label class="overview-label mt-5 mb-3">Organisation Overview</label>
    <div class="row row-padding pb-3">
      <div class="p-0 col-4-companies mask mb-3" (mouseover)="changeText=true" (mouseout)="changeText=false"
        routerLink="/companies/companies-list">
        <span *ngIf="!changeText"><img class="image-pos" src="/assets/images/companies-enrolled-overview.png" /></span>
        <span *ngIf="changeText"> <img class="image-pos"
            src="/assets/images/companies-enrolled-overview-hover.png" /></span>
        <!-- <img   *ngIf="!this.hover && index==0" class="image-pos" src="/assets/images/companies-enrolled-overview.png"  />
                            <img  *ngIf="this.hover && index==0" class="image-pos" src="/assets/images/companies-enrolled-overview-hover.png"  /> -->
        <div class="p-4">
          <span class="main-text">Companies
            <br>enrolled</span>
          <div class="pt-2 number-text">{{overviewData?.companiesEnrolled}}</div>
        </div>

      </div>
      <div class="p-0 col-4-employees-enrolled mask " (mouseover)="changeEmployeeText=true"
        (mouseout)="changeEmployeeText=false" routerLink="/members/members-list">
        <span *ngIf="!changeEmployeeText"><img class="image-pos-employees-enrolled"
            src="/assets/images/overview-employees-enrolled.png" /></span>
        <span *ngIf="changeEmployeeText"> <img class="image-pos-employees-enrolled"
            src="/assets/images/overview-employees-enrolled-hover.png" /></span>
        <!-- <img   *ngIf="!this.hover && index==1" class="image-pos-employees-enrolled" src="/assets/images/overview-employees-enrolled.png"  />
                            <img  *ngIf="this.hover && index==1" class="image-pos-employees-enrolled" src="/assets/images/overview-employees-enrolled-hover.png"  /> -->
        <div class="p-4">
          <span class="main-text">Employees
            <br>enrolled</span>
          <div class="pt-2 number-text">{{overviewData?.employeesEnrolled}}</div>
        </div>

      </div>
      <div class="p-0 col-4-employees-checked-in mask" (mouseover)="changeEmployeeCheckedText=true"
        (mouseout)="changeEmployeeCheckedText=false">
        <span *ngIf="!changeEmployeeCheckedText"><img class="image-pos-employees-checked-in"
            src="/assets/images/overview-employees-checked-in-today.png" /></span>
        <span *ngIf="changeEmployeeCheckedText"> <img class="image-pos-employees-checked-in"
            src="/assets/images/overview-employees-checked-in-hover.png" /></span>
        <div class="p-4">
          <span class="main-text">Employees
            <br>checked-in today</span>
          <div class="pt-2 number-text">{{overviewData?.employeesCheckedIn}}</div>
        </div>

      </div>
      <div class="p-0 col-4-day-pass mask " (mouseover)="changeDayPassText=true" (mouseout)="changeDayPassText=false">
        <span *ngIf="!changeDayPassText"><img class="image-pos-day-pass"
            src="/assets/images/overview-day-pass-today.png" /></span>
        <span *ngIf="changeDayPassText"> <img class="image-pos-day-pass"
            src="/assets/images/overview-day-pass-hover.png" /></span>
        <div class="p-4">
          <span class="main-text">Day Pass Today</span>
          <div class="pt-4 number-text">10</div>
          <div class="sub-text pt-1">50 Visitors Today</div>
        </div>

      </div>
      <div class="p-0 col-4-compli-credit mask mb-3" (mouseover)="changeCompliCredit=true" routerLink="/credits"
        (mouseout)="changeCompliCredit=false">
        <span *ngIf="!changeCompliCredit"><img class="image-pos-credit"
            src="/assets/images/overview-compli-credit.png" /></span>
        <span *ngIf="changeCompliCredit"> <img class="image-pos-credit"
            src="/assets/images/overview-credit-hover.png" /></span>
        <div class="p-4">
          <span class="main-text">Complimentary
            <br>Active Credit points</span>
          <div class="pt-2 number-text">{{overviewData?.complimentaryActiveCreditPoints}}</div>
          <div class="sub-text pt-1">{{overviewData?.complimentarySoldCreditPoints}} Credit points sold
            this month</div>
        </div>

      </div>
      <div class="p-0 col-4-compli-credit mask " (mouseover)="changeClaCredit=true" (mouseout)="changeClaCredit=false"
        routerLink="/credits">
        <span *ngIf="!changeClaCredit"><img class="image-pos-credit"
            src="/assets/images/overview-compli-credit.png" /></span>
        <span *ngIf="changeClaCredit"> <img class="image-pos-credit"
            src="/assets/images/overview-credit-hover.png" /></span>
        <div class="p-4">
          <span class="main-text">CL Admin Credit
            <br>Points
          </span>
          <div class="pt-2 number-text">{{overviewData?.claCreditPoint}}</div>
        </div>

      </div>
      <div class="p-0 col-4-meetings mask" (mouseover)="changeMeetingRoomsText=true"
        (mouseout)="changeMeetingRoomsText=false" (click)="routeToMeetingReport()">
        <span *ngIf="!changeMeetingRoomsText"><img class="image-pos-meeting"
            src="/assets/images/overview-meeting-rooms.png" /></span>
        <span *ngIf="changeMeetingRoomsText"> <img class="image-pos-meeting"
            src="/assets/images/overview-meetings-hover.png" /></span>
        <div class="p-4">
          <span class="main-text">Meeting Rooms
            <br>Booked Today</span>
          <div class="pt-2 number-text">{{overviewData?.meetingRoomsBookedToday}}</div>
          <div class="sub-text pt-1">for {{overviewData?.meetingRoomsBookedTodayDuration}} hours</div>
        </div>

      </div>
      <div class="p-0 col-4-parking mask" (mouseover)="changeParkingText=true" (mouseout)="changeParkingText=false">
        <span *ngIf="!changeParkingText"><img class="image-pos-parking"
            src="/assets/images/overview-parking.png" /></span>
        <span *ngIf="changeParkingText"> <img class="image-pos-parking"
            src="/assets/images/overview-parking-hover.png" /></span>
        <div class="p-4">
          <span class="main-text">Parking Allocated</span>
          <div class="row col-12 pl-0 pr-0 pt-5 m-0 d-flex flex-row">
            <div class="col-6 p-0 flex-column">
              <div><span class="denom-number-font">{{overviewData?.fourWheelParkings}} </span><span
                  class="number-font">/50</span></div>
              <div class="sub-text pt-1">4 Wheeler</div>
            </div>
            <div class="col-6 p-0 flex-column">
              <div><span class="denom-number-font">{{overviewData?.twoWheelParkings}}</span><span
                  class="number-font">/50</span></div>
              <div class="sub-text pt-1">2 Wheeler</div>
            </div>
          </div>
        </div>

      </div>
    </div>
  </div>




</div>
<div>
